<script lang="ts">
import { Line } from 'vue-chartjs'
import Vue from 'vue'

// Типы
interface DataItem {
  time: string | Date
  value: number | string
  [key: string]: any
}

interface ChartDataset {
  data: number[]
  label?: string
  backgroundColor?: string
  borderColor?: string
  fill?: boolean
  [key: string]: any
}

interface ChartDataStruct {
  labels: string[]
  datasets: ChartDataset[]
}

interface ZoomPluginOptions {
  zoom?: {
    enabled?: boolean
    drag?: boolean
    mode?: string
    speed?: number
    rangeMin?: { x: number | null; y: number | null }
    rangeMax?: { x: number | null; y: number | null }
    onZoom?: (context: { chart: any }) => void
    onZoomComplete?: (context: { chart: any }) => void
  }
  pan?: {
    enabled?: boolean
    mode?: string
    speed?: number
  }
}

interface ChartOptionsExtended extends ChartOptions {
  plugins?: {
    zoom?: ZoomPluginOptions
  }
  scales?: {
    yAxes?: Array<{
      ticks?: {
        display?: boolean
        min?: number
        max?: number
        stepSize?: number
        reverse?: boolean
        beginAtZero?: boolean
      }
      scaleLabel?: {
        display?: boolean
        labelString?: string
      }
    }>
  }
  onClick?: (e: Event) => void
  onDblclick?: (e: Event) => void
}

export default Vue.extend({
  name: 'LINE_CHART',

  extends: Line,

  props: {
    data: {
      type: Array as () => DataItem[],
      default: () => []
    },
    measure: {
      type: Object as () => Record<string, any>,
      default: () => ({})
    },
  },

  data(): {
    chartdata: ChartDataStruct
    options: ChartOptionsExtended
  } {
    return {
      chartdata: {
        labels: ['miau'],
        datasets: [
          {
            data: [300, 1500, 450, 750, 450]
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        events: ['click', 'dblclick', 'mousemove'],
        legend: { display: false },
        onClick: (e: Event) => {
          console.log(`I'm onClick!!!`, e)
          console.log('getDataSet', this)
        },
        onDblclick: (e: Event) => {
          console.log(`I'm onDblclick!!!`, e)
        },
        plugins: {
          zoom: {
            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: true,

              // Enable drag-to-zoom behavior
              drag: true,
              // Drag-to-zoom effect can be customized
              // drag: {
              // 	 borderColor: 'rgba(225,225,225,0.3)'
              // 	 borderWidth: 5,
              // 	 backgroundColor: 'rgb(225,225,225)',
              // 	 animationDuration: 0
              // },

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              // A function that is called as the user is zooming and returns the
              // available directions can also be used:
              //   mode: function({ chart }) {
              //     return 'xy';
              //   },
              mode: 'x',

              rangeMin: {
                // Format of min zoom range depends on scale type
                x: null,
                y: null
              },
              rangeMax: {
                // Format of max zoom range depends on scale type
                x: null,
                y: null
              },

              // Speed of zoom via mouse wheel
              // (percentage of zoom on a wheel event)
              speed: 0.1,

              // Function called while the user is zooming
              onZoom: ({ chart }: { chart: any }) => { console.log(`I'm OOOOOOOO`, chart) },
              // onZoom: function({chart}) { console.log(`I'm zooming!!!`, chart) },
              // Function called once zooming is completed
              onZoomComplete: ({ chart }: { chart: any }) => { console.log(`I was zoomed!!!`, chart) }
            }
          }
        }
      }
    }
  },

  watch: {
    data: {
      handler(newVal: DataItem[]): void {
        console.log('WATCH', this.$options.name, 'data', newVal)
        this.tableCreate()
      },
      deep: true
    },
  },

  methods: {
    getDataSet(e: Event): void {
      console.log('getDataSet', (this as any).$data._chart)
    },

    tableCreate(): void {
      this.chartdata.labels = []
      this.chartdata.datasets[0].data = []

      if (this.data.length) {
        this.data.forEach((item: DataItem) => {
          this.chartdata.labels.push((this as any).$moment(item.time).format('DD.MM HH:mm:ss'))
          this.chartdata.datasets[0].data.push(typeof item.value === 'number' ? item.value : parseFloat(item.value as string))
        })
      }

      if (typeof this.measure.value !== 'number') {
        const scales = {
          yAxes: [{
            ticks: {
              display: true,
              min: 0,
              max: 2,
              stepSize: 1,
              reverse: false,
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: (this as any).$getTranslate(this.measure.value)
            }
          }]
        }
        this.$set(this.options, 'scales', scales)
      }

      // @ts-ignore - renderChart метод из vue-chartjs
      this.renderChart(this.chartdata, this.options)
    },
  },
})
</script>

<style lang="css" scoped>
</style>
